import { render } from "./Conferences.vue?vue&type=template&id=64a2b113&scoped=true"
import script from "./Conferences.vue?vue&type=script&lang=js"
export * from "./Conferences.vue?vue&type=script&lang=js"

import "../assets/css/table.css?vue&type=style&index=0&id=64a2b113&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a2b113"]])

export default __exports__